import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons"
import { navigate } from "gatsby"

const ContactForm = () => {

  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
  }

  const handleChange = e => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = e => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "Enquiry", ...formState })
    })
    .then(() => navigate("/thank-you/")).catch(error => alert(error));

    e.preventDefault();
  }

  return (
  <form name="Enquiry" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleSubmit}>
    <input name="name" type="text" placeholder="Full Name" required="true" onChange={handleChange} value={formState.name} />
    <input name="phone" type="tel" placeholder="Phone" required="true" onChange={handleChange} value={formState.phone} />
    <input name="email" type="email" placeholder="E-mail" required="true" onChange={handleChange} value={formState.email} />
    <textarea
      name="message"
      placeholder="Share your message"
      rows="3"
      data-gramm_editor="false"
      onChange={handleChange}
      value={formState.message}
    ></textarea>
    <button>Send Message</button>
  </form>
)
}

export default ContactForm